<ion-textarea mode="md"
              labelPlacement="stacked"
              [label]="label"
              [formControl]="control"
              [placeholder]="placeholder"
              auto-grow="true"
              [rows]="minRows"
              fill="outline"></ion-textarea>
